"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPermissionsFromDefinition = exports.getIgnoredOperations = exports.getMappedOperations = exports.getPermissionsForOperation = void 0;
/**
 *
 * @param operation The GQL operation name which will be used to find associated Permissions for
 * @param permissionDefinition An object of type PermissionDefinition
 * @returns An array of permission-keys (strings) which contain the given operation
 */
const getPermissionsForOperation = (operation, permissionDefinition) => {
    return permissionDefinition.permissions
        .filter((permission) => { var _a; return (_a = permission.gqlOperations) === null || _a === void 0 ? void 0 : _a.includes(operation); })
        .map((permission) => permission.key);
};
exports.getPermissionsForOperation = getPermissionsForOperation;
/**
 * The function reads and returns all mapped operations in the permission definition object except which are marked as IGNORE.
 * @param permissionDefinition An object of type PermissionDefinition
 */
const getMappedOperations = (permissionDefinition) => {
    var _a;
    const otherOperations = permissionDefinition.permissions.map((permission) => permission.gqlOperations);
    const anonymousOperations = ((_a = permissionDefinition.gqlOptions) === null || _a === void 0 ? void 0 : _a.anonymousGqlOperations) ||
        new Array();
    return [
        ...new Set(Array().concat(...otherOperations.filter(Array.isArray), anonymousOperations)),
    ];
};
exports.getMappedOperations = getMappedOperations;
/**
 * The function reads and returns operations in the permission definition object which are marked as IGNORE.
 * @param permissionDefinition An object of type PermissionDefinition
 */
const getIgnoredOperations = (permissionDefinition) => {
    var _a;
    return (_a = permissionDefinition.gqlOptions) === null || _a === void 0 ? void 0 : _a.ignoredGqlOperations;
};
exports.getIgnoredOperations = getIgnoredOperations;
/**
 * Returns all permission keys.
 * @param permissionDefinition An object of type PermissionDefinition
 */
const getPermissionsFromDefinition = (permissionDefinition) => {
    return permissionDefinition.permissions.map((permission) => permission.key);
};
exports.getPermissionsFromDefinition = getPermissionsFromDefinition;
//# sourceMappingURL=mappings-helpers.js.map